import React from 'react';
import { getActiveIcon } from 'library/helpers';
import { durationString } from 'library/time';
import { DocLink, DocPages } from 'components/Help/';
import LegFormInput from './input';

const config = {
  init: {
    active: true
  },
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        defaultSortOrder: 'ascend'
      },
      {
        title: 'Type',
        dataIndex: 'type__name',
        width: '200px',
        sorter: true,
        render: (text, record) => (record.type ? record.type.name : '')
      },
      {
        title: 'Duration',
        dataIndex: 'duration',
        width: '120px',
        align: 'center',
        sorter: true,
        render: (text, record) => (durationString(record.duration))
      },
      {
        title: 'Active',
        dataIndex: 'active',
        width: '140px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [
          {
            text: 'Yes',
            value: true
          },
          {
            text: 'No',
            value: false
          }
        ],
        render: (text, record) => getActiveIcon(record.active)
      }
    ],
    // Deleting
    confirmMessage: item => (
      <div>
        <p>
          Are you sure you wish to delete the leg
          <b>{item.name}</b>
          ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      },
      type__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['type__name'],
        searchValue: ''
      }
    },
    // General
    title: <DocLink page={DocPages.availabilityLegs}>Legs</DocLink>
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select a Leg',
    title: 'Leg',
    tabItems: [
      {
        key: 0,
        title: 'Details',
        component: props => (
          <LegFormInput
            {...props}
            title="Leg"
          />
        )
      }
    ]
  }
};

export default config;
